import React from "react";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import classNames from "classnames";

import { icons, IconTypes } from "./../../../constants/icons";

export interface IconProps {
  icon: IconTypes;
  fontSize?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
  "data-cy"?: string;
  customClassName?: string;
  customSvgAttributes?: Partial<FontAwesomeIconProps>;
  id?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const Icon: React.FC<IconProps> = ({
  icon,
  fontSize,
  "data-cy": dataCy,
  customClassName,
  customSvgAttributes: customAttributes,
  id,
  onMouseEnter,
  onMouseLeave,
}) => {
  const classes = classNames(
    fontSize ? `fds-font-size-${fontSize} fds-line-height-${fontSize}` : "",
    customClassName,
  );
  return (
    <FontAwesomeIcon
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classes}
      icon={icons[icon]}
      data-cy={dataCy}
      id={id}
      {...customAttributes}
    ></FontAwesomeIcon>
  );
};

export default Icon;
